import React from 'react';
import './Testimonials.css';
import { Link } from 'react-router-dom';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      text: "« Nous avons doublé notre chiffre d'affaires au 2ème trimestre grâce à l'approche Prosperian. Une méthode qui fonctionne vraiment ! »",
      author: "Jérôme Thupoin",
      position: "Directeur Commercial"
    },
    {
      id: 2,
      text: "« Prosperian a insufflé une énergie qui a remis en mouvement notre équipe commerciale. Cet accompagnement nous a repositionné dans une dynamique de résultats. »",
      author: "Marie Armand",
      position: "CEO"
    },
    {
      id: 3,
      text: "« Prosperian a redynamisé l'équipe commerciale par une approche tournée vers l'humain et vers le résultat. Une expertise qui a permis de rebooster les commerciaux ! »",
      author: "Jérôme Laloy",
      position: "Responsable Marketing et Commercial"
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <h2 className="testimonials-title">Ils nous ont fait confiance</h2>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card" data-aos="fade-up" data-aos-delay={testimonial.id * 100}>
              <div className="testimonial-content">
                <p className="testimonial-text">{testimonial.text}</p>
              </div>
              
              <div className="testimonial-footer">
                <h3 className="testimonial-author">{testimonial.author}</h3>
                <p className="testimonial-position">{testimonial.position}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="testimonial-cta">
          <Link to="/etudes-de-cas">
            <button className="testimonial-cta-button">Voir les études de cas</button>
          </Link>
          <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer">
            <button className="testimonial-contact-button">Contactez-nous</button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 